<template>
    <Layout title="Словарь фраз" :content-class="'content--narrow dictionary'">
        <div class="dictionary__top">
            <SearchInput
                placeholder="Введите слово, слог"
                class="dictionary__search"
                @change="onSearch"
            />
            <CustomSelect
                v-model="filters.language"
                :options="languages"
                :form-value-text="(item) => item.label.original || item.label[$i18n.locale]"
                with-filter
                class="select--filter"
                emit-prop="id"
                empty-text="No languages"
                placeholder="Язык"
                style="margin-left: 10px; width: 200px"
                clearable
            >
                <template #default="{ item }">
                    {{ item.label.original || item.label[$i18n.locale] }}
                </template>
            </CustomSelect>
            <CustomSelect
                v-model="filters.provider"
                :options="providers"
                :form-value-text="(item) => item.name"
                emit-prop="id"
                class="select--filter"
                placeholder="Провайдер"
                clearable
            >
                <template #default="{ item }">
                    {{ item.name }}
                </template>
            </CustomSelect>
            <button
                class="button button--medium"
                style="height: 36px"
                type="button"
                @click="showAddModal()"
            >
                + Добавить
            </button>
        </div>
        <table class="phoneme-table">
            <thead class="phoneme-table__head">
                <th class="phoneme-table__head-cell" style="width: 8%"></th>
                <th class="phoneme-table__head-cell" style="width: 25%">Исходный</th>
                <th class="phoneme-table__head-cell" style="width: 25%">Замена</th>
                <th class="phoneme-table__head-cell" style="width: 15%">Язык</th>
                <th class="phoneme-table__head-cell" style="width: 15%">Провайдер</th>
                <th class="phoneme-table__head-cell"></th>
            </thead>
            <TransitionGroup v-if="dictionary.length" tag="tbody" name="fade">
                <tr v-for="phrase in dictionary" :key="phrase.id" class="phoneme-table__row">
                    <td class="phoneme-table__cell">
                        <Switcher
                            :model-value="phrase.is_active"
                            @update:model-value="changeActivity(phrase)"
                        />
                    </td>
                    <td class="phoneme-table__cell">
                        <a href="#" class="link" @click.prevent="showAddModal(phrase)">
                            {{ phrase.phrase }}
                        </a>
                    </td>
                    <td class="phoneme-table__cell">{{ phrase.replace }}</td>
                    <td class="phoneme-table__cell">
                        {{ phrase.language.label.original || phrase.language.label[$i18n.locale] }}
                    </td>
                    <td class="phoneme-table__cell">
                        {{ phrase.provider.name }}
                    </td>
                    <td class="phoneme-table__cell">
                        <button
                            class="button button--blank phoneme-table__bin"
                            type="button"
                            style="margin-right: 10px"
                            @click="showAddModal(phrase)"
                        >
                            Редактировать
                        </button>
                        <button
                            class="button button--blank phoneme-table__bin"
                            type="button"
                            @click="deletePhrase(phrase.id)"
                        >
                            <svg
                                height="15"
                                width="15"
                                viewBox="-40 0 427 427.001"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M232.398 154.703c-5.523 0-10 4.477-10 10v189c0 5.52 4.477 10 10 10 5.524 0 10-4.48 10-10v-189c0-5.523-4.476-10-10-10zm0 0M114.398 154.703c-5.523 0-10 4.477-10 10v189c0 5.52 4.477 10 10 10 5.524 0 10-4.48 10-10v-189c0-5.523-4.476-10-10-10zm0 0"
                                />
                                <path
                                    d="M28.398 127.121V373.5c0 14.563 5.34 28.238 14.668 38.05A49.246 49.246 0 0078.796 427H268a49.233 49.233 0 0035.73-15.45c9.329-9.812 14.668-23.487 14.668-38.05V127.121c18.543-4.922 30.559-22.836 28.079-41.863-2.485-19.024-18.692-33.254-37.88-33.258h-51.199V39.5a39.289 39.289 0 00-11.539-28.031A39.288 39.288 0 00217.797 0H129a39.288 39.288 0 00-28.063 11.469A39.289 39.289 0 0089.398 39.5V52H38.2C19.012 52.004 2.805 66.234.32 85.258c-2.48 19.027 9.535 36.941 28.078 41.863zM268 407H78.797c-17.098 0-30.399-14.688-30.399-33.5V128h250v245.5c0 18.813-13.3 33.5-30.398 33.5zM109.398 39.5a19.25 19.25 0 015.676-13.895A19.26 19.26 0 01129 20h88.797a19.26 19.26 0 0113.926 5.605 19.244 19.244 0 015.675 13.895V52h-128zM38.2 72h270.399c9.941 0 18 8.059 18 18s-8.059 18-18 18H38.199c-9.941 0-18-8.059-18-18s8.059-18 18-18zm0 0"
                                />
                                <path
                                    d="M173.398 154.703c-5.523 0-10 4.477-10 10v189c0 5.52 4.477 10 10 10 5.524 0 10-4.48 10-10v-189c0-5.523-4.476-10-10-10zm0 0"
                                />
                            </svg>
                            Удалить
                        </button>
                    </td>
                </tr>
            </TransitionGroup>
            <tbody v-if="!dictionary.length">
                <tr clas="phoneme-table__row">
                    <td class="phoneme-table__cell" colspan="6">
                        {{ $t('misc.notfound') }}
                    </td>
                </tr>
            </tbody>
            <tbody v-if="loading">
                <tr clas="phoneme-table__row">
                    <td class="phoneme-table__cell" colspan="3">
                        <Spinner v-if="loading" class="spinner--gray" />
                    </td>
                </tr>
            </tbody>
        </table>
        <button
            v-if="canLoadMore"
            class="button button--centered button--medium"
            type="button"
            style="margin-top: 30px"
            :disabled="loading"
            @click="loadMore"
        >
            Загрузить ещё
        </button>
        <DictionaryPhraseModal
            v-if="modalVisible"
            :phrase="currentPhrase"
            :languages="languages"
            :providers="providers"
            @closed="onModalClosed"
        />
    </Layout>
</template>

<script>
import { ApiClient } from '@/plugins/axios';
import Layout from '@speechki-frontend/shared/ui/layout/Layout';
import { DictionaryPhraseModal } from '../../components';
import Switcher from '@speechki-frontend/shared/ui/Switcher/Switcher';
import { CustomSelect, SearchInput } from '@speechki-frontend/shared/ui/forms';

import { mapGetters, mapActions } from 'vuex';

export default {
    name: 'DictionaryPage',
    components: {
        Layout,
        DictionaryPhraseModal,
        Switcher,
        CustomSelect,
        SearchInput,
    },
    data() {
        return {
            search: '',
            dictionary: [],
            loading: false,
            pageSize: 20,
            page: 1,
            count: 0,
            providers: [],
            languages: [],
            modalVisible: false,
            currentPhrase: undefined,
            filters: {
                language: undefined,
                provider: undefined,
            },
        };
    },
    computed: {
        ...mapGetters(['isStaff', 'isAdmin']),
        canLoadMore() {
            return this.count > this.page * this.pageSize;
        },
    },
    watch: {
        page() {
            this.fetchDictionary();
        },
        'filters.language': {
            handler() {
                this.page = 1;
                this.fetchDictionary();
            },
        },
        'filters.provider': {
            handler() {
                this.page = 1;
                this.fetchDictionary();
            },
        },
    },
    async created() {
        if (!this.isStaff && !this.isAdmin) {
            this.$router.push('/');
        }
        await Promise.all([this.fetchLanguages(), this.fetchProviders(), this.fetchDictionary()]);
    },
    methods: {
        ...mapActions(['pushToast']),
        async fetchDictionary() {
            this.loading = true;
            const params = {
                page_size: this.pageSize,
                page: this.page,
                ordering: '-id',
            };

            if (this.search) {
                params.search = this.search;
            }

            if (this.filters.language) {
                params.language = this.filters.language;
            }

            if (this.filters.provider) {
                params.provider = this.filters.provider;
            }

            const { results, count } = await ApiClient.get(
                '/api/v1/admin/phrase_dictionary/phrases/',
                { params }
            );

            if (this.page > 1) {
                this.dictionary = [...this.dictionary, ...results];
            } else {
                this.dictionary = results;
            }
            this.count = count;

            this.loading = false;
        },
        async fetchProviders() {
            const { results } = await ApiClient.get('/api/v1/admin/speech_settings/providers/');
            this.providers = results;
        },
        async fetchLanguages() {
            const { results } = await ApiClient.get('/api/v1/admin/speech_settings/languages/');
            this.languages = results;
        },
        loadMore() {
            this.page = this.page + 1;
        },
        onSearch(searchString) {
            this.search = searchString;
            this.page = 1;
            this.fetchDictionary();
        },
        showAddModal(phrase = false) {
            if (phrase) {
                this.currentPhrase = phrase;
            }

            this.modalVisible = true;
        },
        onModalClosed(reload) {
            this.modalVisible = false;
            this.currentPhrase = undefined;

            if (reload) {
                this.fetchDictionary();
            }
        },
        async changeActivity(phrase) {
            await ApiClient.put(`/api/v1/admin/phrase_dictionary/phrases/${phrase.id}/`, {
                phrase: phrase.phrase,
                replace: phrase.replace,
                provider: phrase.provider.id,
                language: phrase.language.id,
                is_active: !phrase.is_active,
            });
            await this.fetchDictionary();
        },
        async deletePhrase(phrase) {
            try {
                await ApiClient.delete(`/api/v1/admin/phrase_dictionary/phrases/${phrase}/`);
                this.fetchDictionary();
            } catch (e) {
                console.log(e);
            }
        },
    },
};
</script>

<style lang="scss" src="./DictionaryPage.scss"></style>
